module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN319_1601731449.2568e06b.png";